
import WokeDoneList from '@/pages/components/manage/dictionary/objectives/WokeDoneList';

export default {
    list: WokeDoneList,
    recordRepresentation: 'content',
};


